module.exports = __webpack_public_path__ + "static/img/loading.023234e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/loading/loading.gif
// module id = oUtA
// module chunks = 0 1 2 3 4 5 7